import { Pipe, PipeTransform } from '@angular/core'
import * as moment from 'moment'
import * as R from 'ramda'

@Pipe({
  name: 'epochUTC',
})
export class EpochUTCPipe implements PipeTransform {
  transform(value: any, format = 'ddd MMM DD, YYYY'): string {
    if (moment.isMoment(value)) {
      return value.utc().format(format)
    }
    if (moment.isDate(value)) {
      return moment.utc(value).format(format)
    }
    if (R.is(Number, value)) {
      return value === 0 ? 'Never' : moment.utc(value * 1000).format(format)
    }
    if (R.is(String, value)) {
      return moment.utc(new Date(value)).format(format)
    }
    return 'Never'
  }
}
